var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.58 27.85",
    enableBackground: "new 0 0 34.58 27.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M31.83,27.85H2.74C1.23,27.85,0,26.62,0,25.1V2.74C0,1.23,1.23,0,2.74,0h29.09c1.51,0,2.74,1.23,2.74,2.74 V25.1C34.58,26.62,33.35,27.85,31.83,27.85z M2.74,1C1.78,1,1,1.78,1,2.74V25.1c0,0.96,0.78,1.74,1.74,1.74h29.09 c0.96,0,1.74-0.78,1.74-1.74V2.74c0-0.96-0.78-1.74-1.74-1.74H2.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M19.58,6.36H5.86c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h13.72c0.28,0,0.5,0.22,0.5,0.5 S19.86,6.36,19.58,6.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M16.01,11.09H5.86c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h10.15c0.28,0,0.5,0.22,0.5,0.5 S16.29,11.09,16.01,11.09z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/Title.06ec46a888debc76e8240593d3ad386d.svg";
export { ForwardRef as ReactComponent };